import styled, { StyledFunction } from 'styled-components';
import { elevation2 } from '../../sharedStyle/elevation';

interface ICard {
  padding?: string;
}
const StyledDiv: StyledFunction<ICard & React.HTMLProps<HTMLInputElement>> = styled.div;
const Card = StyledDiv`
  display: flex;
  flex-direction: column;
  border-radius: 2px;
  padding: ${props => props.padding || 0};
  margin-bottom: 8px;
  background-color: #fff;
  ${elevation2};
`;

export default Card;



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/presentation/component/base/Card.tsx